import { SubscriptionPlan } from 'briefpoint-client';
import Button from 'components/Button';
import { SubscriptionPlanType } from 'services/FirmService';
import { ButtonGroup } from 'react-bootstrap';
import styles from "./Signup.module.scss";

function UnlimitedPlanCard(plan: SubscriptionPlanType, onClick: (plan: SubscriptionPlanType, getStarted: boolean) => void, intervalSwitch: React.Dispatch<React.SetStateAction<boolean>>) {

  return (
    <div className={`${styles.cardContainer} p-4 plan-card mb-4 highlight`}>
      <div className="p-2">
        <h2 className={`${styles.cardHeader} mb-4`}>
          {`${plan.plan !== SubscriptionPlan.YearlyBundle ? 'Solo' : 'Team'}`}
        </h2>
        {plan.plan !== SubscriptionPlan.YearlyBundle ?
          <div className="d-flex justify-content-center mb-3">
            <ButtonGroup className={styles.pricingButtonWrapper}>
              <Button className={plan.plan !== SubscriptionPlan.Monthly ? styles.pricingButtonActive : styles.pricingButtonInactive} onClick={() => intervalSwitch(false)} >
                Yearly
              </Button>
              <Button className={plan.plan === SubscriptionPlan.Monthly ? styles.pricingButtonActive : styles.pricingButtonInactive} onClick={() => intervalSwitch(true)} >
                Monthly
              </Button>
            </ButtonGroup>
          </div>
          : <div>&nbsp;</div>}
        {plan.plan === SubscriptionPlan.YearlyBundle ?
          <>
            <div className='price'>
              <div className={`${styles.teamText} mb-2`}>
                Explore pricing options for firms at scale. Click Get Started, or contact <a href="mailto:sales@briefpoint.ai?subject=Briefpoint Pricing Inquiry">sales@briefpoint.ai</a>.</div>
            </div>
          </> : <>
            <div className='prices'>
              <div className='price-split left'>
                <div>{plan.monthlyPrice || plan.priceString}</div>
                <p className="text-secondary">Per attorney/&#10;&#13;month</p>
              </div>
              <div className='slash'></div>
              <div className='right price-split' >
                <div>{plan.plan === SubscriptionPlan.Monthly ? '$59' : '$49'}</div>
                <p className="text-secondary">Per paralegal/&#10;&#13;month</p>
              </div>
            </div>
          </>
        }
        <br />
        <Button className={`${styles.cardButton} mt-3`} onClick={() => { onClick(plan, plan.plan === SubscriptionPlan.YearlyBundle ? true : false); }} >
          {plan.plan === SubscriptionPlan.YearlyBundle ? 'Get Started': 'Sign Up Now'}
        </Button>
      </div>
    </div>
  );
}

export default function PlanCard({
  plan,
  onClick,
  intervalSwitch
}: {
  plan: SubscriptionPlanType;
  compareToPlan?: SubscriptionPlanType | null;
  onClick: (plan: SubscriptionPlanType, getStarted: boolean) => void;
  intervalSwitch: React.Dispatch<React.SetStateAction<boolean>>
}) {
  return UnlimitedPlanCard(plan, onClick, intervalSwitch);
}
